import {Component, Input, OnInit} from '@angular/core';
import {Group} from "../../models/group";
import {GroupService} from "../../services/group/group.service";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {merge} from "rxjs";
import {GroupModal} from "../../modals/group-modal/group-modal.component";
import {MessagesService} from "../../services/messages/messages.service";

@Component({
    selector: 'app-groups',
    templateUrl: './groups.component.html',
    styleUrls: ['./groups.component.scss']
})
export class GroupsComponent implements OnInit {

    @Input() projectId: string;
    @Input() databaseId: string;

    groups: Array<Group> = [];

    constructor(
        private modalService: NgbModal,
        private groupService: GroupService,
        private messagesService: MessagesService
    ) {
    }

    ngOnInit() {
        merge(
            this.groupService.getAllMyGroups(this.projectId, this.databaseId),
            this.groupService.onChange
        ).subscribe(
            () => this.groups = this.groupService.groups,
            err => this.messagesService.errorToast(err));
    }

    onShowModal() {
        const modalRef = this.modalService.open(GroupModal, {size: 'lg'});
        modalRef.componentInstance.projectId = this.projectId;
        modalRef.componentInstance.databaseId = this.databaseId;
    }

    onDelete(groupId) {
        this.messagesService.confirmModal().result
            .then(
                result => {
                    if (result) {
                        this.groupService.deleteGroup(this.projectId, this.databaseId, groupId)
                            .subscribe(
                                () => this.messagesService.successToast('Group deleted.'),
                                err => this.messagesService.errorToast(err)
                            );
                    }
                },
                reason => {
                }
            ).catch(err => console.error(err));
    }
}